<template lang="html">
  <div class="course" :class="{ active: showInfo }" v-if="course">
    <div
      class="course-col text grid br"
      :class="{ bb: !showInfo || course.image.length < 1 }"
    >
      <div v-if="course.category" class="course-category uc grey">
        <span v-if="course.group">{{ course.group }} | </span>
        <span>{{ course.category }}</span>
        <span v-if="course.points"> | {{ course.points }} ECTS Credits</span>
      </div>
      <h1
        class="course-name link black"
        @click="(showInfo = !showInfo), (activeFaculty = null)"
      >
        {{ course.title }}
      </h1>
      <div v-if="course.datetype !== 'none'" class="course-date">
        <div
          v-if="course.datetype === 'recurring' && course.day"
          class="fl grey"
        >
          {{ course.day }}, {{ course.starttime }}–{{ course.endtime }}
        </div>
        <div
          v-if="course.datetype === 'once' && course.startdate"
          class="fl grey"
        >
          {{ course.startdate
          }}<span v-if="course.enddate">–{{ course.enddate }}</span>
        </div>
        <div v-if="course.datetype === 'interval'" class="fl grey">
          <div v-for="(interval, index) in course.interval" :key="index">
            {{ interval.startdate
            }}<span v-if="interval.enddate">–{{ interval.enddate }}</span>
          </div>
        </div>
      </div>
      <div v-if="showInfo" class="course-info">
        <div class="course-description" v-html="course.description" />
      </div>

      <div
        class="course-faculty"
        v-for="faculty in course.faculty"
        :key="faculty.uid"
      >
        <div class="link" @click="toggleFaculty(faculty.uid)">
          <div class="uc">
            <img
              v-if="activeFaculty == faculty.uid"
              class="arrow up"
              src="./../assets/icons/arrow.svg"
            /><img
              v-if="activeFaculty !== faculty.uid"
              class="arrow down"
              src="./../assets/icons/arrow.svg"
            />&nbsp;
            {{ faculty.title }}
          </div>
        </div>
        <div v-if="activeFaculty == faculty.uid" class="faculty-info gt">
          <div class="faculty-portrait">
            <img
              class="pht"
              v-if="faculty.portrait.length > 0"
              :src="faculty.portrait[0].url"
              :alt="faculty.title"
            />
          </div>
          <div class="faculty-biography pr pb" v-html="faculty.biography" />
        </div>
      </div>
    </div>
    <div v-if="showInfo && course.image.length > 0" class="course-col bb">
      <div class="course-image">
        <img :src="course.image[0].url" :alt="course.title" />
        <figcaption
          v-if="course.image[0].caption"
          class="phl pb"
          v-html="course.image[0].caption"
        ></figcaption>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    course: Object
  },
  data() {
    return {
      showInfo: false,
      showFacultyInfo: false,
      activeFaculty: null
    };
  },
  // mounted() {
  //   if (window.innerWidth < 768) {
  //     console.log("is Mobile");
  //     if (this.showInfo) {
  //       this.showBorder = false;
  //     } else {
  //       this.showBorder = true;
  //     }
  //   } else {
  //     this.showBorder = true;
  //   }
  // },
  methods: {
    toggleFaculty(id) {
      this.showInfo = true;
      if (this.activeFaculty === id) {
        this.activeFaculty = null;
      } else {
        this.activeFaculty = id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course {
  position: relative;
  display: grid;
  page-break-inside: avoid;
  grid-template-columns: minmax(0, 1fr) minmax(0, calc(33% + 3px));
  @media only screen and (max-width: 768px) {
    grid-template-columns: 100vw;
    .course-col {
      border-right: 0 !important;
    }
  }
  @media only screen and (min-width: 768px) {
    .text {
      border-bottom: 1px solid black !important;
    }
  }
  // &.active {
  //   .text {
  //     @media only screen and (max-width: 768px) {
  //       border-bottom: 0px !important;
  //     }
  //   }
  // }
  .course-col {
    position: relative;
    &.grid {
      display: grid;
      grid-template-columns: 1fr;
      grid-auto-rows: max-content;
      grid-gap: calc(0.5 * var(--lh));
      padding: calc(0.5 * var(--lh));
    }
  }
  .course-image {
    width: 100%;
    height: auto;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      top: -1px;
      left: 0;
      width: 100%;
      height: 1px;
      background: black;
      @media only screen and (max-width: 768px) {
        display: none;
      }
    }
    img {
      width: 100%;
    }
    figcaption {
      width: 100%;
    }
  }
}
</style>
